export default class ListPetroStationRequest
{
    constructor(
        public petrolCompanyId?: number,
        public petrolStationId?: number
    ) {
    }
}
